import './index.less';

import classNames from 'classnames';
import { useMemo } from 'react';

import { useMediaQueryDevice } from '@/components/MediaQuery';
import { CHAIN_ID } from '@/constants/chain';

import Empty from '@/components/Empty';
import { useTokenBalanceList } from '../hook';
import BalanceItem from './BalanceItem';
import BalanceItemMobile from './BalanceItemMobile';
interface IProps {
  chainId: CHAIN_ID | undefined;
}
export default function BalanceList({ chainId }: IProps): JSX.Element {
  const tokenBalanceList = useTokenBalanceList(chainId);
  const { isMobile, deviceType } = useMediaQueryDevice();

  const tokenListFiltered = useMemo(() => {
    const list = tokenBalanceList?.filter((t) => t.balance.gt(0)) || [];

    return list.sort((a, b) => {
      if (a.balance.gt(0) && b.balance.eq(0)) return -1;
      if (a.balance.eq(0) && b.balance.gt(0)) return 1;
      return 0;
    });
  }, [tokenBalanceList]);
  return (
    <div className={classNames('balance-list', 'syn-scrollbar', deviceType)}>
      {tokenListFiltered.map((balanceInfo) =>
        isMobile ? (
          <BalanceItemMobile key={balanceInfo.address} balanceInfo={balanceInfo} />
        ) : (
          <BalanceItem key={balanceInfo.address} balanceInfo={balanceInfo}></BalanceItem>
        ),
      )}
      {!isMobile && tokenListFiltered.length % 2 !== 0 && <BalanceItem key="placeholder" balanceInfo={undefined} />}
      {!tokenListFiltered.length && <Empty />}
    </div>
  );
}
